var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"type":_vm.type,"value":_vm.value,"autocomplete":"off","hide-details":""},on:{"input":_vm.onInput,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onEnter.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }